import { loggerMethods, serializeError } from './logger-utils';

function log(level) {
  return (data, message) => {
    // eslint-disable-next-line no-param-reassign
    if (data.err) data.err = serializeError(data.err);

    if (Object.keys(data).length > 0) {
      // eslint-disable-next-line no-console
      console[level](message, data);
    } else {
      // eslint-disable-next-line no-console
      console[level](message);
    }

    window.newrelic?.log?.(message, { level, customAttributes: { ...data } });
  };
}

// Creating a client logger
export const clientLogger = loggerMethods.reduce((acc, level) => {
  acc[level] = log(level);
  return acc;
}, {});
